var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 177.54 116.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00519b;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        opacity: .5;\r\n      }\r\n\r\n      .cls-5 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-2);\r\n        mix-blend-mode: screen;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #292a2d;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #f0ad1c;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient);\r\n        mix-blend-mode: multiply;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #66ccdb;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 90.78,
    y1: 109.72,
    x2: 90.78,
    y2: 90.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#dce7ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#94b5ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#5a8eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3171a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#186095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f5a91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 91.17,
    y1: 62.63,
    x2: 91.17,
    y2: 32.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d97d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M38.71,105.25c0,9.47-5.36,11.14-11.98,11.14h-3.29c-6.62,0-11.98-1.68-11.98-11.14v-37.53c0-9.47,5.36-17.14,11.98-17.14h3.29c6.62,0,11.98,7.67,11.98,17.14v37.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.01,105.25c0,9.47-5.36,11.14-11.98,11.14h-3.29c-6.62,0-11.98-1.68-11.98-11.14v-37.53c0-9.47,5.36-17.14,11.98-17.14h3.29c6.62,0,11.98,7.67,11.98,17.14v37.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 17.95,
    y: 54.86,
    width: 146.72,
    height: 48.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.95,91.32c0,3.2-2.59,5.79-5.79,5.79s-5.79-2.59-5.79-5.79,2.59-5.79,5.79-5.79,5.79,2.59,5.79,5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.38,65.46c0,2.25-1.82,4.07-4.07,4.07s-4.07-1.82-4.07-4.07,1.82-4.07,4.07-4.07,4.07,1.82,4.07,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.16,65.46c0,1.02-.83,1.85-1.85,1.85s-1.84-.83-1.84-1.85.83-1.84,1.84-1.84,1.85.83,1.85,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M156.39,65.46c0,2.25-1.82,4.07-4.07,4.07s-4.07-1.82-4.07-4.07,1.82-4.07,4.07-4.07,4.07,1.82,4.07,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.82,91.03c0,3.2-2.59,5.79-5.79,5.79s-5.79-2.59-5.79-5.79,2.59-5.79,5.79-5.79,5.79,2.59,5.79,5.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.16,65.46c0,1.02-.83,1.85-1.85,1.85s-1.84-.83-1.84-1.85.83-1.84,1.84-1.84,1.85.83,1.85,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.5,35.6c0-6.83-7.14-5.89-7.14-5.89h-4.57c-6.83,0-7.99,5.84-8,5.89-1.85-5.35-9.43-26.23-16.14-30.46C133.93.29,90.79,0,90.79,0c0,0-43.15.29-50.86,5.14-6.72,4.23-14.29,25.12-16.14,30.46h-3.86s-1.14-5.89-8-5.89h-4.57S.21,28.78.21,35.6c0,0-1.57,6.4,3.86,6.4h13.13c-3.54,3.6-6.7,8.59-6.7,16.57v32s-3,19.14,25.43,19.14h109.72c28.43,0,25.43-19.14,25.43-19.14v-32c0-7.99-3.16-12.97-6.7-16.57h9.27c4.54,0,3.86-6.4,3.86-6.4ZM159.76,59.57s1.29,11.14-8.57,12.54c-9.86,1.39-19.5,2.04-19.5,2.04,0,0,.86-9.43,7.61-11.79,6.75-2.36,20.47-2.79,20.47-2.79ZM35.35,29.07l3.61-9.64c3.61-9.64,8.49-10.29,17.19-11.36,8.7-1.07,34.87-1.5,34.87-1.5,0,0,26.16.43,34.87,1.5,8.7,1.07,13.59,1.71,17.19,11.36l3.61,9.64s3.18,8.79-7.22,8.79H42.57c-10.4,0-7.22-8.79-7.22-8.79ZM21.81,59.57s13.71.43,20.47,2.79c6.75,2.36,7.61,11.79,7.61,11.79,0,0-9.64-.64-19.5-2.04s-8.57-12.54-8.57-12.54ZM48.71,100.79h-18.68s-11.04,1.32-11.04-11.29h36.43s-1.14,11.29-6.71,11.29ZM116.36,92.58s-1,5.29-9,5.29h-33.15c-8,0-9-5.29-9-5.29,0,0-.35-.93-.88-2.43h52.9c-.53,1.5-.88,2.43-.88,2.43ZM120.71,78.72h-59.85c-1.52-6.14-2.35-12.32-.08-13.86,4.86-3.29,30-3,30-3,0,0,25.14-.29,30,3,2.28,1.54,1.45,7.72-.08,13.86ZM155.86,100.79h-18.68s-11.04,1.32-11.04-11.29h36.43s-1.14,11.29-6.71,11.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M171.07,90.57s-5.93,14.67-28.21,14.67H38.71c-22.28,0-28.21-14.67-28.21-14.67,0,0-3,19.14,25.43,19.14h109.71c28.43,0,25.43-19.14,25.43-19.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M153.61,39.47c-.92-3.03-1.79-6.13-1.92-7.38-.06,2.37-1.53,5.37-8.59,5.37H39.24c-7.06,0-8.53-3-8.59-5.37-.14,1.25-1.01,4.36-1.92,7.38-.92,3.05.35,6.31,3.14,8.01,9,5.49,26.27,15.95,27.79,15.1,4.54-2.55,24.9-2.79,31.52-2.8,6.61,0,26.97.24,31.52,2.8,1.51.85,18.78-9.61,27.79-15.1,2.79-1.7,4.06-4.96,3.14-8.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M91.02,37.79h52.22c11.21,0,7.78-9.47,7.78-9.47l-3.89-10.39c-3.89-10.39-9.15-11.09-18.53-12.24-9.38-1.15-37.57-1.62-37.57-1.62,0,0-28.2.46-37.57,1.62-9.38,1.15-14.64,1.85-18.53,12.24l-3.89,10.39s-3.43,9.47,7.78,9.47h52.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.05,6.22c-7.21.16-22.99.57-29.25,1.34-8.22,1.01-12.84,1.62-16.25,10.73l-3.41,9.11s-3.01,8.3,6.82,8.3h57.96l-15.88-29.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.06,6.19c-1.77.04-4.07.09-6.61.16l15.79,29.32h6.7l-15.88-29.49Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarro);
export default __webpack_public_path__ + "static/media/CARRO.c0bb24d2558be3404a8d7abb36613954.svg";
export { ForwardRef as ReactComponent };